import { ICultureClient } from "@multiweb/clients/culture";
import { ILanguage, ILanguageExtended } from "@multiweb/types/contracts";
import { ASServices } from "OW.Remoting/Basic/ServiceEndpoints";
import { CancellationToken } from "../../../../../Global/Base/Promises/CancellationTokenSource";
import { getCancellationTokenAsRequestContext } from "../../../RequestContext";
import { BaseClient } from "../BaseClient";

export interface ILanguageDTO {
    Culture: string;
    Kod: string;
    Popis: string;
    Primarni: boolean;
    Viditelny: boolean;
    ID: any;
    Hierarchie: any;
}

/**
 * @internal
 */
export class LegacyUpTo1503CultureClient extends BaseClient implements ICultureClient {
    private _languagesLoading: Promise<readonly ILanguageExtended[]>;

    public async setLanguage(_language: string, _cancellationToken: CancellationToken = CancellationToken.none): Promise<ILanguage> {
        throw new Error("Not implemented");
    }

    public getSupportedLanguages(cancellationToken: CancellationToken = CancellationToken.none): Promise<readonly ILanguageExtended[]> {
        // jazyky se za běhu aplikace nemohou měnit, takže je možné je kešovat
        if (this._languagesLoading === undefined)
            this._languagesLoading = (this._communicationManager.callGETRequest("SupportedCultures", ASServices.cultures, undefined, undefined, getCancellationTokenAsRequestContext(cancellationToken)) as Promise<ILanguageDTO[]>)
                .then(languages => languages.map(convertLanguageExtended));
        return this._languagesLoading;
    }

    public async getCurrentLanguage(cancellationToken: CancellationToken = CancellationToken.none): Promise<ILanguage> {
        const culture = await (this._communicationManager.callGETRequest("CurrentCulture", ASServices.cultures, undefined, undefined, getCancellationTokenAsRequestContext(cancellationToken)) as Promise<string>);
        const languages = await this.getSupportedLanguages(cancellationToken);
        return languages.find(langInfo => langInfo.culture === culture);
    }

    public async saveLanguageProfile(_language: string, _cancellationToken: CancellationToken = CancellationToken.none): Promise<boolean> {
        throw new Error("Not implemented");
    }

    public async loadLanguageProfile(_cancellationToken: CancellationToken = CancellationToken.none): Promise<string | null> {
        throw new Error("Not implemented");
    }
}

const convertLanguageExtended = (dto: ILanguageDTO): ILanguageExtended => ({
    code: dto.Kod,
    culture: dto.Culture,
    isPrimary: dto.Primarni,
    description: dto.Popis,
});
